
import { useLocation, Link, useParams } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import { translations } from "@/utils/translations";
import { updateMetaTags } from "@/utils/seoUtils";

const NotFound = () => {
  const location = useLocation();
  const { lang } = useParams<{ lang: string }>();
  const { currentLanguage, setLanguage } = useLanguage();
  const t = translations[currentLanguage];

  useEffect(() => {
    // If a language parameter is available in the URL, set it as current language
    if (lang && (lang === 'de' || lang === 'en' || lang === 'fr' || lang === 'it')) {
      setLanguage(lang);
    }
    
    // Set SEO meta tags for 404 page
    updateMetaTags({
      title: `404 - ${currentLanguage === 'de' ? 'Seite nicht gefunden' : 
              currentLanguage === 'fr' ? 'Page non trouvée' :
              currentLanguage === 'it' ? 'Pagina non trovata' :
              'Page not found'} | Future Level`,
      description: 'Die gesuchte Seite wurde nicht gefunden. Bitte versuchen Sie einen anderen Link oder kehren Sie zur Startseite zurück.',
      keywords: "404, not found, page not found, error page, Future Level",
      language: currentLanguage,
      // Don't set canonical for 404 pages
    });
    
    // Add noindex meta tag for 404 pages to prevent indexing
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      metaRobots.setAttribute('content', 'noindex, follow');
    } else {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      metaRobots.setAttribute('content', 'noindex, follow');
      document.head.appendChild(metaRobots);
    }
    
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname, lang, setLanguage, currentLanguage]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow flex items-center justify-center bg-gray-50 py-32">
        <div className="text-center container px-4">
          <h1 className="text-6xl md:text-8xl font-bold mb-6 text-futurelevel-purple">404</h1>
          <p className="text-xl text-gray-600 mb-8">
            {currentLanguage === 'de' ? 'Oops! Diese Seite wurde nicht gefunden.' : 
             currentLanguage === 'fr' ? 'Oops! Page non trouvée.' :
             currentLanguage === 'it' ? 'Oops! Pagina non trovata.' :
             'Oops! Page not found.'}
          </p>
          <Link to={`/${currentLanguage}`} className="button-primary inline-block">
            {currentLanguage === 'de' ? 'Zurück zur Startseite' : 
             currentLanguage === 'fr' ? 'Retour à l\'accueil' :
             currentLanguage === 'it' ? 'Torna alla home' :
             'Return to Home'}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
